import {ActionableError} from './base/actionable-error'

export class ActionableUnknownError extends ActionableError {
  constructor(
    message: string,
    public cause: unknown
  ) {
    super(message)
    this.name = 'ActionableUnknownError'
  }
}
